import { MAP_TYPES } from '@deck.gl/carto';

const BROWARDPARCEL_SOURCE_ID = 'browardParcelSource';

const source = {
  id: BROWARDPARCEL_SOURCE_ID,
  type: MAP_TYPES.TILESET,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.sample_dataset.BCPA_PROPERTY_DATA_Tileset`,
};

export default source;
